import { mergeStreamableComponentsData } from 'site-modules/personalized-search/utils/merge-streamable-components-data';
import { useMemo } from 'react';

export function useAccumulatedComponentData({ items, initialData }) {
  return useMemo(
    () => mergeStreamableComponentsData([initialData, ...items.map(item => item.data)]),
    [initialData, items]
  );
}
